import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigBathroomModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async bathroomConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.bathroomConfig(patientId)
    },
    async updateBathroomConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updateBathroomConfig(config)
    }
  }
}
